export default "__VITE_ASSET__ZHgGTOjt__"